import { Common } from '@stockbit/ui';
import { Skeleton } from 'antd';

const { Flex } = Common;

function SuggestionItemLoading() {
  return (
    <Flex align="center" justify="space-between" py="10px">
      <Flex direction="column">
        <Skeleton.Input size="small" active style={{ width: 75, height: 17 }} />
        <Skeleton.Input
          size="small"
          active
          style={{ width: 125, height: 14 }}
        />
      </Flex>
      <Skeleton.Button size="small" active style={{ width: 72 }} />
    </Flex>
  );
}

export default SuggestionItemLoading;
